import axios from "axios"

const url = 'linkdrive/plataforma'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  async loginPlataforma(_, params) {
    const { email, senha } = params
    const { data: user } = await axios(`${url}/login/plataforma`, {
      params: {
        email,
        senha
      }
    })

    return user
  },

  async loginGoogle(_, params) {
    const { data: token } = await axios.post(`${url}/login/google`, params)
    
    return token
  },

  async recuperarSenha(_, params) {
    const { email } = params
    const { data: resp } = await axios.put(`${url}/recuperar-senha/${email}`)

    return resp
  },
  
  async cadastrarUsuarioPlataforma(_, params) {
    const { data: resp } = await axios.post(`${url}/cadastro/plataforma`, params)

    return resp
  },
  async cadastrarImagemUsuario(_, params) {
    const { id, imagem } = params
    let formData = null
    formData = new FormData()
    formData.append('arquivo', imagem)
    const { data: resp } = await axios.post(`${url}/cadastro/imagem-perfil/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    })

    return resp
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}